import { CONTAINER_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import FlexColumn from '../../layout/flex/column.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Body text container for the feature banner component',
  extends: [pick(CONTAINER_ARGS, [{ name: 'tag', default: 'p' }])],
  name: 'Feature Banner Body',
});

export default class SpdsFeedbackFeatureBannerBody extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-feedback-feature-banner-body';

  get tag() {
    return this.argOrDefault('tag');
  }

  <template>
    <FlexColumn
      @tag={{this.tag}}
      class={{this.classes}}
      data-test-spds-feedback-feature-banner-body
      ...attributes
    >
      {{yield}}
    </FlexColumn>
  </template>
}

export const FEATURE_BANNER_BODY_METADATA = SpdsFeedbackFeatureBannerBody.metadata;
